import { render, staticRenderFns } from "./attachment-editor.vue?vue&type=template&id=7a57134f&"
import script from "./attachment-editor.vue?vue&type=script&lang=ts&"
export * from "./attachment-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports